import {Color} from '@mintdata/mint-kit/api/models/Color';
import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {IPropertyConverter} from '@mintdata/mint-kit/api/properties/PropertyConverter';
import {ValidationMessages} from '@mintdata/mint-kit/api/properties/ValidationMessages';
import {ValidationResult} from '@mintdata/mint-kit/api/properties/ValidationResult';
import {Empty} from '@mintdata/mint-kit/api/types/Value';
import {AError} from '@mintdata/mint-kit/api/values/AError';

export class ColorConverter implements IPropertyConverter<Color>
{
    public validate(aColorString:string, isRequired:boolean = true):ValidationResult
    {
        aColorString = (aColorString || '').toLowerCase().trim();

        if( aColorString.length === 0 )
        {
            if( isRequired )
                return ValidationResult.error(ValidationMessages.nonEmpty(Color));
            else
                return ValidationResult.valid();
        }

        if( ColorConverter.HEXA_COLOR_VALIDATION_REGEXP.test(aColorString) )
            return ValidationResult.valid();
        else
            return ValidationResult.error(ValidationMessages.unknownValue(aColorString, Color));
    }

    public validateValue(color:Color, isRequired:boolean = true):ValidationResult
    {
        return this.validate(color && color.toHexString(), isRequired);
    }

    public valueToString(aColor:Color, isFocused:boolean = false):string
    {
        if( aColor === Empty )
            return '';

        return aColor != null ? aColor.toHexString() : '';
    }

    public stringToValue(aColorString:string, isRequired:boolean = true):Color | AError
    {
        aColorString = (aColorString || '').trim();

        if( !isRequired && aColorString.length === 0 )
            return Empty;

        const color:Color = Color.fromHexString(aColorString);

        if( color )
            return color;

        return AError.fromString('Invalid Color value: ' + aColorString);
    }

    public static readonly HEXA_COLOR_VALIDATION_REGEXP = /^#([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
    public static readonly HEX_FIELD:FieldPath = 'hex';
    public static readonly RED_FIELD:FieldPath = 'red';
    public static readonly GREEN_FIELD:FieldPath = 'green';
    public static readonly BLUE_FIELD:FieldPath = 'blue';
    public static readonly ALPHA_FIELD:FieldPath = 'alpha';
    public static readonly RGBA_FIELD:FieldPath = 'rgba';
}
